import server from "@/api/server";

/**
 * @param {Object} data
 * @param {string[]} data.stg - тип продукта(-ов) / всегда массивом: 'FNS.REG', 'ACCOPEN', 'MERCHANT.IA', 'MERCHANT.TA'
 * @param {string} data.company_name
 * @param {string} data.inn
 * @param {string} data.ogrn
 * @param {string} data.person_fullname
 * @param {string} data.person_phone
 * @param {string} data.person_email
 * @param {string} data.comment
 * @param {string} data.company_type  - FL или UL (ИП или ООО)
 */
async function createNewBid(data) {
  let res = await server.post("/agent/agent/app/add", data);
  return res;
}

/**
 * @typedef {Object} BidDetails
 * @property {string} num - номер заявки
 * @property {string} dadd - дата добавления
 * @property {string} clid
 * @property {string} state - статус (статичный пока что)
 * @property {Array} stg - массив (тип продуктов)
 * @property {string} inn
 * @property {string} company_name
 * @property {string} person_phone
 * @property {string} company_type - FL или UL
 * @property {string} person_fullname
 * @property {string} person_email
 * @property {Array} files - массив прикрепленных файлов
 * @property {string} status
 */

/**
 * Отправляет запрос за деталями заявки
 * @param {string} id - id заявки
 * @returns {Promise<BidDetails>} детали заявки
 */
async function getBid(id) {
  let res = await server.post("/agent/agent/app/get", { id });
  return res;
}

/**
 * @param {Object} data
 * @param {string} data.page
 * @param {string} data.pageSize
 * @param {string} data.filter
 * @param {string} data.search_query
 */
async function getBids(data) {
  let res = await server.post("/agent/agent/app/list", data);
  return res;
}

async function meetingSlots(data) {
  let res = await server.post("/agent/agent/meeting/get_slots", data);
  return res;
}

async function meetingReserve(data) {
  let res = await server.post("/agent/agent/meeting/reserve", data);
  return res;
}

async function meetingUnreserve(data) {
  let res = await server.post("/agent/agent/meeting/unreserve", data);
  return res;
}

async function meetingSearchAddress(q) {
  let res = await server.post("/agent/agent/misc/search_address", q);
  return res;
}


export { createNewBid, getBid, getBids, meetingSlots, meetingReserve,  meetingUnreserve, meetingSearchAddress};
